import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Button,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import useError from "Hooks/useError";
import { message } from "constants/message";
import {
  RotateLeft,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Upload/useApi";
import useAuth from "Hooks/Upload/useAuth";
import MuiAlert from "@material-ui/lab/Alert";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
  subtitle: {
    marginLeft: "5px",
    marginBottom: "5px",
  },
  accountInfo: {
    display: "inline-box",
    width: "120px",
  },
  datepicker: {
    display: "flex",
    alignItems: "baseline",
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  contractCell: {
    width: "120px",
  },
  idCol: {
    minWidth: "80px;",
  },
  dateTimeCol: {
    width: "180px;",
  },
  importCountCol: {
    minWidth: "135px;",
  },
  statusCol: {
    minWidth: "105px;",
  },
  buttonCol: {
    textAlign: "center",
  },
  buttonRed: {
    color: "rgb(220, 0, 78)",
    "&:hover": {
      backgroundColor: "rgba(220, 0, 78, 0.04)",
    },
  },
  alert: {
    marginTop: theme.spacing(2),
  },
  selectFormControl: {
    width: "250px"
  },
}));

function Imports(props) {
  const { params } = props.match;
  const accountId = parseInt(params.accountId, 10);
  const groupId = parseInt(params.groupId, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const classes = useStyles();
  const messages = message();

  const [account, setAccount] = React.useState({});
  const [group, setGroup] = React.useState({});
  const [imports, setImports] = React.useState([]);
  const [importUrl, setImportUrl] = React.useState("");
  const [isShowModal, setIsShowModal] = React.useState(false);
  const [cancelId, setCancelId] = React.useState(null);
  const [success, setSuccess] = React.useState(false);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Upload - アップロード詳細";
    stateError.initialize();
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAccount();
    fetchGroup();
    fetchImports();
  }, [auth.state.token]);

  const fetchAccount = () => {
    request({
      method: "GET",
      url: `media/upload/accounts/${accountId}`,
    }).then((result) => {
      setAccount(result.data.data);
    });
  };

  const fetchGroup = () => {
    request({
      method: "GET",
      url: `media/upload/groups/${accountId}/${groupId}`,
    }).then((result) => {
      setGroup(result.data.data);
    });
  };

  const fetchImports = () => {
    request({
      method: "GET",
      url: `media/upload/imports/${groupId}`,
    }).then((result) => {
      setImports(result.data.data);
    });
  };

  const openDialog = (id) => {
    setCancelId(id);
    setIsShowModal(true);
  };

  const cancelImport = () => {
    setSuccess(false);
    request({
      method: "PUT",
      url: `media/upload/imports/${groupId}/${cancelId}`,
    }).then((result) => {
      setImports(result.data.meta.imports);
    });
    setIsShowModal(false);
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell className={classes.idCol}>{row.id}</TableCell>
          <TableCell className={classes.dateTimeCol}>
            {dayjs(row.created_at).format("YYYY/MM/DD HH:mm:ss")}
          </TableCell>
          <TableCell>{row.filename}</TableCell>
          <TableCell className={classes.dateTimeCol}>
            {row.started_at ? dayjs(row.started_at).format("YYYY/MM/DD HH:mm:ss") : "-"}
          </TableCell>
          <TableCell className={classes.dateTimeCol}>
            {row.finished_at ? dayjs(row.finished_at).format("YYYY/MM/DD HH:mm:ss") : "-"}
          </TableCell>
          <TableCell className={classes.importCountCol}>
            {row.num_imported ? row.num_imported + "件" : "-"}
          </TableCell>
          <TableCell className={classes.statusCol}>{row.status}</TableCell>
          <TableCell className={classes.buttonCol}>
            {row.status === "imported" && (
              <IconButton 
                className={classes.buttonRed} 
                aria-label="add an RestartAlt"
                onClick={() => openDialog(row.id)}
              >
                <RotateLeft />
              </IconButton>
            ) || (
              "-"
            )}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  // URL入力形式確認用バリデーションを追加
  ValidatorForm.addValidationRule('checkImportUrl', (value) => {
    if (!value) return true; 
    // URLの正規表現
    const regexp = /https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g;

    if (!regexp.test(value)) {
      return false;
    } else {
      return true;
    }
  });

  const handleSubmit = ({ importUrl }) => {
    setSuccess(false);
    request({
      method: "POST",
      url: `media/upload/imports/${groupId}`,
      data: {
        import_url: importUrl,
      },
    })
      .then((data) => {
        stateError.initialize();
        setImportUrl("");
        setSuccess(true);
        setImports(data.data.meta.imports);
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                アカウント詳細
              </Typography>
              <Grid container>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    アカウントID
                  </Typography>
                  <Typography variant="inherit" >
                    {account.id}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    アカウント名
                  </Typography>
                  <Typography variant="inherit" >
                    {account.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    収集グループ名
                  </Typography>
                  <Typography variant="inherit" >
                    {group.name}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    概要
                  </Typography>
                  <Typography variant="inherit" >
                    {group.desc}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                ダウンロードURL
              </Typography>
              <Grid container>
                <Grid item xs={12} className={classes.wrapper}>
                <ValidatorForm
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(
                      { 
                        importUrl,
                      }
                    );
                  }}
                  onError={onError}
                >
                  <Typography variant="subtitle2" className={classes.subtitle}>
                    ※MeltwaterのダウンロードURLを下に貼り付けて下さい。
                  </Typography>
                  <Typography variant="subtitle2" className={classes.subtitle}>
                    ※登録されたファイルは即取込処理が開始されます。
                  </Typography>
                  <Grid item xs={12} className={classes.wrapper}>
                    <TextValidator
                      label="取込ファイルのダウンロードURL"
                      multiline
                      minRows={3}
                      maxRows={3}
                      fullWidth
                      value={importUrl}
                      onChange={(event) => {
                        setImportUrl(event.target.value);
                      }}
                      type="text"
                      validators={['required', 'checkImportUrl']}
                      errorMessages={[
                        messages.validation.required,
                        messages.validation.isImportUrlRegexp 
                      ]}
                    />
                  </Grid>
                  {stateError.state.isError && (
                    <div className={classes.messsageWrapper}>
                      <MuiAlert
                        elevation={6}
                        variant="filled"
                        severity="error"
                        className={classes.toast}
                      >
                        {stateError.state.errorMsg}
                      </MuiAlert>
                    </div>
                  )}

                  <Grid container justifyContent="center" className={classes.wrapper}>
                    <Button type="submit" variant="contained" color="primary">
                      登録
                    </Button>
                  </Grid>
                </ValidatorForm>
                </Grid>
              </Grid>
            </Paper>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                取込履歴
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>履歴ID</TableCell>
                    <TableCell>登録日時</TableCell>
                    <TableCell>ファイル名</TableCell>
                    <TableCell>処理開始日時</TableCell>
                    <TableCell>処理終了日時</TableCell>
                    <TableCell>取込データ件数</TableCell>
                    <TableCell>ステータス</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {imports.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
            {success && (
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="success"
                className={classes.alert}
              >
                登録が完了しました
              </MuiAlert>
            )}
          </Grid>
          <Dialog open={isShowModal} onClose={() => setIsShowModal(false)}>
            <DialogContent>
              <DialogContentText>
                本当に取り消してよろしいですか？
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={cancelImport}>
                はい
              </Button>
              <Button color="primary" onClick={() => setIsShowModal(false)}>
                いいえ
              </Button>
            </DialogActions>
          </Dialog>
        </>
      }
    />
  );
}

export default withRouter(Imports);
